const EnglishFlag = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="24" fill="#012169" />
    <path d="M0 0L32 24M32 0L0 24" stroke="#FFFFFF" strokeWidth="2.5" />
    <path d="M0 0L32 24M32 0L0 24" stroke="#C8102E" strokeWidth="1.5" />
    <path d="M16 0V24M0 12H32" stroke="#FFFFFF" strokeWidth="4" />
    <path d="M16 0V24M0 12H32" stroke="#C8102E" strokeWidth="2.5" />
  </svg>
);

export default EnglishFlag;
